(ns frontend.ux-overhaul.listing.generic.menu-actions
  "Actions of the \"...\" menu of a listing toolbar that the legacy grids of the same
   entity type have: the field requirements of the creator, and the toggle of the
   landing page. A listing puts them at the end of its `:toolbar-actions`. The
   pipeline listings already have both, from `pipeline-entity`.

   Each function reads the session when it is called, so a listing calls them when
   it starts, as it builds the other actions. The toggle of the landing page is a
   component that reads the preference of the account when it renders.

   The action of the field requirements only sets the state of the editor. The
   listing must also render `field-requirements-modal`, or no dialog opens."
  (:require
   [frontend.view.grid.common.utils :as grid-utils]
   [ui.editors.entity-creator.view :as creator-editor]))

(defn field-requirements-action
  "The action that opens the field requirements of the creator of `entity-type`.
   It is nil for a user who is not an administrator, for a tenant that has no
   custom create config, and for an entity type that cannot be configured. The
   listing keeps no nil in its actions: the runtime of a listing drops it."
  [{:keys [entity-type]}]
  (grid-utils/creator-config-toolbar-action {:entity-type entity-type}))

(defn field-requirements-modal
  "The dialog of the field requirements. It shows only while the editor state is
   open, so a listing can always render it. The pipeline listing and the legacy
   grids render the same dialog."
  []
  [creator-editor/modal-view])

(defn landing-page-action
  "The item of the menu with the toggle of the landing page. The account keeps one
   preference, so the toggle of a listing is on only while the account has this
   listing as its landing page. `view-id` is the id of the route of the listing,
   for example `:persons-grid`. The listing has no empty icon before the label,
   so the label has no inset."
  [{:keys [view-id]}]
  (grid-utils/preferred-landing-page-toggle {:view-id view-id
                                             :inset?  false}))
